import React, { Component } from "react";
import {setTitle} from '../../../utils/utils';
import styles from './index.less';
export default class LocationInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {} 
    setTitle('位置信息');
  }

  componentDidMount() {

  }


  render() {
    let countParams = this.props.location.query;
    console.log('location---count---', countParams)
    return (
      <div className={styles.personal}>
        <div className="list"><div className="label">填写装货地时</div><div className="info">获取{countParams.orderCount}次</div></div>
        <div className="list"><div className="label">填写卸货地时</div><div className="info">获取{countParams.orderCount}次</div></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/locationInfo/index.js